function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCyber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Shield"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.059 11.002C40.745 10.042 32.857.471 32.78.374A1.002 1.002 0 0 0 32 .001H32a1 1 0 0 0-.78.375c-.077.096-7.912 9.663-24.278 10.626A1 1 0 0 0 6 12v26.416a21.109 21.109 0 0 0 11.913 18.931l13.654 6.554a.998.998 0 0 0 .866 0l13.654-6.554A21.109 21.109 0 0 0 58 38.416V12a1 1 0 0 0-.941-.998zM56 38.415a19.1 19.1 0 0 1-10.778 17.13L32 61.89l-13.222-6.347A19.1 19.1 0 0 1 8 38.416V12.934C21.868 11.838 29.627 4.97 32 2.498c2.373 2.473 10.132 9.34 24 10.436z",
    style: {
      fill: "#063085"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.334 4.515a38.892 38.892 0 0 1-21.452 9.237 1 1 0 0 0-.882.993v23.67a18.092 18.092 0 0 0 10.21 16.228l12.357 5.93a.997.997 0 0 0 .866 0l12.356-5.93A18.092 18.092 0 0 0 55 38.416v-23.67a1 1 0 0 0-.882-.994 38.892 38.892 0 0 1-21.452-9.237.999.999 0 0 0-1.332 0zM53 15.625v22.79a16.083 16.083 0 0 1-9.076 14.425L32 58.563 20.076 52.84A16.083 16.083 0 0 1 11 38.415v-22.79a41.047 41.047 0 0 0 21-9.04 41.047 41.047 0 0 0 21 9.04z",
    style: {
      fill: "#063085"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 24v3h-1a3.003 3.003 0 0 0-3 3v10a3.003 3.003 0 0 0 3 3h12a3.003 3.003 0 0 0 3-3V30a3.003 3.003 0 0 0-3-3h-1v-3a5 5 0 0 0-10 0zm12 6v10a1.001 1.001 0 0 1-1 1H26a1.001 1.001 0 0 1-1-1V30a1.001 1.001 0 0 1 1-1h12a1.001 1.001 0 0 1 1 1zm-4-6v3h-6v-3a3 3 0 0 1 6 0z",
    style: {
      fill: "#063085"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 31a2.993 2.993 0 0 0-1 5.816V38a1 1 0 0 0 2 0v-1.184A2.993 2.993 0 0 0 32 31zm0 4a1 1 0 1 1 1-1 1.001 1.001 0 0 1-1 1z",
    style: {
      fill: "#063085"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyber);
export default __webpack_public_path__ + "static/media/cyber.3c6859672f8258005fee8e719f824587.svg";
export { ForwardRef as ReactComponent };